import { render, staticRenderFns } from "./ContractView.vue?vue&type=template&id=19e61d7b&"
import script from "./ContractView.vue?vue&type=script&lang=js&"
export * from "./ContractView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports